const FR = require('../I18n/languages/fr')
const EN = require('../I18n/languages/en')
const NL = require('../I18n/languages/nl')

export const translation = (language, key) => {
  if (language === 'en') {
    return EN[key] || key
  } if (language === 'fr') {
    return FR[key] || key
  } if (language === 'nl') {
    return NL[key] || key
  }
}
